import { render, staticRenderFns } from "./Event.vue?vue&type=template&id=a9632f9e&"
import script from "./Event.vue?vue&type=script&lang=js&"
export * from "./Event.vue?vue&type=script&lang=js&"
import style0 from "./Event.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4282463623/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a9632f9e')) {
      api.createRecord('a9632f9e', component.options)
    } else {
      api.reload('a9632f9e', component.options)
    }
    module.hot.accept("./Event.vue?vue&type=template&id=a9632f9e&", function () {
      api.rerender('a9632f9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/Events/Event.vue"
export default component.exports